import slardar from '@slardar/web';

const isKA = process.env.IS_KA && process.env.IS_KA === 'true';

export function registerSlardar() {
    if (isKA) return;

    if (process.env.NODE_ENV === 'production') {
        const isInLarkWebview = navigator.userAgent.indexOf('Lark') !== -1;
        slardar('init', {
            bid: 'hire_web',
            env: 'otps'
        });

        slardar('context.merge', { isInLarkWebview });

        slardar('start');
    }
}

export const slardarTrack = (event: string, params: Record<string, any> = {}) => {
    if (isKA) return;
    if (process.env.NODE_ENV !== 'production') return;
    try {
        slardar('emit', event, params);
    } catch {
        // slardar not initialized, ignore
    }
};
